module.exports = "<navbar-header-text>Рабочий график сотрудников</navbar-header-text>\n<work-schedule *ngIf=\"wsVisible\">\n</work-schedule>"